import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { InvoiceNotificationEmail } from 'src/app/admin/import-invoices/invoice-notification-email.model';
import { EcomItemDto } from '../shared/dto/ecom-item.dto';
import { EcomShippingItemTypeDto } from '../shared/dto/ecom-shipping-item-type.dto';
import { EcomShippingTypeDto } from '../shared/dto/ecom-shipping-type.dto';
import { EcomService } from '../shared/ecom.service';

@Component({
  selector: 'wl-ecom-item-edit-shipping',
  templateUrl: './ecom-item-edit-shipping.component.html',
  styleUrls: ['./ecom-item-edit-shipping.component.less'],
    standalone: false
})
export class EComItemEditShippingComponent implements OnInit, OnChanges {
  @Input() eCommerceItem: EcomItemDto;
  @Output() shippingItemTypeChanged = new EventEmitter<Array<EcomShippingItemTypeDto>>();
  shippingTypes: SelectItem[] = [];
  shippingItemTypes: EcomShippingItemTypeDto[] = [];

  constructor(private _ecomService: EcomService) {}

  ngOnInit(): void {
    this._ecomService.GetShippingTypes().then((data) => {
      this.shippingTypes = data.Result.map<SelectItem>((x) => {
        return { label: x.ShippingType, value: x.ShippingTypeId };
      });
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.eCommerceItem) {
      this.shippingItemTypes = []; // Clear old data

      this._ecomService.GetShippingItemType(this.eCommerceItem.ItemId).then((data) => {
        if (data?.length > 0) {
          this.shippingItemTypes = data;
        }
        this.updateShippingItemType();
      });
    }
  }

  updateShippingItemType() {
    this.shippingItemTypeChanged.emit(this.shippingItemTypes);
  }

  addShippingItemType() {
    this.shippingItemTypes.push({ ItemId: this.eCommerceItem.ItemId } as EcomShippingItemTypeDto);
  }

  deleteShippingItemType(shippingItemType: EcomShippingItemTypeDto) {
    let index = this.shippingItemTypes.indexOf(shippingItemType);
    this.shippingItemTypes.splice(index, 1);
    this.updateShippingItemType();
  }
}
